<div>
    <!-- Page Header -->
    @if (!isProfileView()) {
    <div [class.page-title-wrapper]="true">
        <div class="d-flex justify-content-between flex-wrap gap-3 flex-row">
            <div>
                <!-- Search Input Group -->
                <div class="input-group position-relative">
                    <input id="search" type="text" class="form-control form-control-solid ps-13 pe-5"
                        placeholder="Search Invoices" aria-label="Search Invoices" [ngModel]="propertyChargeFilter.searchTerm"
                        (ngModelChange)="propertyChargeFilter.searchTerm = $event"
                        (keyup.enter)="loadPropertyCharges(false)" aria-describedby="search-description">

                    @if (propertyChargeFilter.searchTerm) {
                    <button
                        class="btn btn-link position-absolute top-50 translate-middle-y p-0 border-0 bg-transparent mx-2 input-group-clear-button"
                        type="button" (click)="clearSearch()" aria-label="Clear search">
                        <fa-duotone-icon icon="xmark" class="text-secondary fs-6" secondaryOpacity="0.9" size="lg" />
                    </button>
                    }

                    <div class="input-group-append">
                        <button class="btn btn-primary rounded-0 rounded-end" type="button"
                            (click)="loadPropertyCharges(false)" id="button-addon2">
                            Search
                        </button>
                    </div>
                </div>
                <!-- Search Input Group -->
                <div id="search-description" class="ps-2 mt-2 text-muted small fst-italic">
                    Search by invoice #, property title, lot number, or address
                </div>
            </div>
            
            <div class="d-flex gap-3">
                <ms-property-charge-search-filter [filter]="propertyChargeFilter"
                    [scheduleOptions]="scheduleOptions()"
                    [preserveScheduleIdsOnReset]="!isInvoiceDashboardView()"
                    [defaultFilterFactory]="defaultFilterFactory()"
                    (filterApplied)="filterApplied()">
                </ms-property-charge-search-filter>

                <ms-sort-dropdown [sortOptions]="sortOptions" [(selectedSortOption)]="orderBy"
                    (selectedSortOptionChange)="setSortOrder($event)"></ms-sort-dropdown>

                <!-- Actions Dropdown -->
                <div class="dropdown bulk-actions-dropdown" [msCloseMenuOnSettle]="isExportingFilteredData()">
                    <button class="btn btn-primary dropdown-toggle" type="button"
                        data-bs-toggle="dropdown" aria-expanded="false">
                        List Actions
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                        <li>
                            <a class="dropdown-item" [class.disabled]="isExportingFilteredData()"
                                [attr.aria-disabled]="isExportingFilteredData() ? 'true' : null"
                                [attr.tabindex]="isExportingFilteredData() ? -1 : null"
                                msDebounceClick
                                (msDebounceClick)="$event.stopPropagation(); exportFilteredData()">
                                @if (isExportingFilteredData()) {
                                <span class="spinner-border spinner-border-sm me-2" role="status"></span>Exporting...
                                } @else {
                                <fa-duotone-icon icon="download" secondaryOpacity="0.9" class="me-2" />Export Filtered Data
                                }
                            </a>
                        </li>
                        @if (showBulkWaiveLateFees()) {
                        <li>
                            <hr class="dropdown-divider">
                        </li>
                        <li *ifHasPermission="{
                            requiredPermissions: [BalancesPermissions.Mark],
                            userPermissionOnly: false
                            }">
                            <a class="dropdown-item" (click)="waiveSelectedLateFees()">
                                <fa-duotone-icon icon="hand-holding-dollar" secondaryOpacity="0.9" class="me-2" />Waive Late Fees
                            </a>
                        </li>
                        }
                        @if (!hideBulkActions()) {
                        <!-- DEV-2370: hidden for MMP - restore Mark as Paid / Void / Lock when ready
                        <li>
                            <hr class="dropdown-divider">
                        </li>
                        <li>
                            <a class="dropdown-item" (click)="markSelectedAsPaid()">
                                <fa-duotone-icon icon="check-circle" secondaryOpacity="0.9" class="me-2" />Mark as Paid
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" (click)="voidSelectedInvoices()">
                                <fa-duotone-icon icon="ban" secondaryOpacity="0.9" class="me-2" />Void
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" (click)="lockSelectedInvoices()">
                                <fa-duotone-icon icon="lock" secondaryOpacity="0.9" class="me-2" />Lock
                            </a>
                        </li>
                        -->
                        }
                        <li>
                            <hr class="dropdown-divider">
                        </li>
                        <li *ifHasPermission="{
                            requiredPermissions: [BalancesPermissions.Read],
                            userPermissionOnly: false
                            }">
                            <a class="dropdown-item"
                                [class.disabled]="selectedCount() === 0 || isBulkResendingInvoices()"
                                (click)="resendSelectedInvoices()">
                                <fa-duotone-icon icon="paper-plane" secondaryOpacity="0.9" class="me-2" />Resend Invoices
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
    }
    
    <div>
        <div class="d-flex justify-content-between align-items-center">

            <div class="mb-0 text-start flex-grow-0"
                [class.w-50]="!isProfileView()"
                #jumpToElementMobile>
                Showing: {{propertyChargeList().length}} of {{totalCount | number}}                
                <div class="badge bg-primary ms-0 ms-sm-2">
                    Selected: {{selectedCount() | number}}
                </div>
            </div>
            
            <div class="flex-grow-1 text-end d-block d-sm-none">
                <button id="toggleAllMobile" type="button" class="btn btn-ms-secondary text-start"
                    (click)="toggleSelectAll()">
                    <fa-duotone-icon icon="square-check" secondaryOpacity="0.2" size="lg" [hidden]="!isSelectAll" />
                    <fa-duotone-icon icon="square" secondaryOpacity="0.2" size="lg" [hidden]="isSelectAll" />
                    {{ (isSelectAll) ? 'Deselect All' : 'Select All' }}
                </button>
            </div>

            @if (isProfileView()) {
            <div class="fs-5 mb-1 text-end d-none d-sm-block mt-1">
                <span class="fw-semibold me-2">Amount Owed:</span>
                <span [class.text-danger]="(totalOwedAmount() && totalOwedAmount() > 0)">{{
                    totalOwedAmount() | CurrencyDisplay: totalCurrency()! | noValue }}</span>
            </div>            
            }
            
        </div>

        @if (isProfileView()) {
        <div class="fs-5 d-block d-sm-none mt-1">
            <span class="fw-semibold me-2">Amount Owed:</span>
            <span [class.text-danger]="(totalOwedAmount() && totalOwedAmount() > 0)">{{
                totalOwedAmount() | CurrencyDisplay: totalCurrency()! | noValue: "$0.00" }}</span>
        </div>

        <span class="d-block d-sm-none mt-2"
            [msTooltip]="onlinePaymentsDisabledTooltip"
            [msTooltipDisabled]="isStripeOnboardingComplete()"
            [attr.tabindex]="isStripeOnboardingComplete() ? -1 : 0">
            <button class="btn bg-success-subtle border-success-subtle text-success w-100"
                [disabled]="totalSelectedAmount() === 0 || !isStripeOnboardingComplete()"
                (click)="payRequested.emit()">
                Pay@if (totalSelectedAmount() > 0) { {{ ' ' + (totalSelectedAmount() | CurrencyDisplay: totalCurrency()!) }} }
            </button>
        </span>
        }

        <!-- Table Start -->
        <div class="table-responsive d-none d-sm-block">
            <table msResponsiveTable class="table table-hover fixed-header placeholder-glow">
                <thead #jumpToElement>
                    <tr>
                        <th msResponsiveTableColumn="checkbox" [priority]="1" scope="col">
                            <input id="toggleAllSelection" name="toggleAllSelection" type="checkbox"
                                class="form-check-input fs-6" [checked]="isSelectAll" (change)="toggleSelectAll()" />
                        </th>
                        <th msResponsiveTableColumn="invoiceId" [priority]="columnPriorities().invoiceId" scope="col" class="sortable" (click)="toggleSortDirection('Invoice #')">
                            Invoice #
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="(orderBy == propertyChargeListSortOptions.PropertyChargeIdAsc) ? '0.9' : '0.3'"
                                [secondaryOpacity]="(orderBy == propertyChargeListSortOptions.PropertyChargeIdDesc) ? '0.9' : '0.3'" />
                        </th>
                        @if (showInvoiceNameColumn()) {
                        <th msResponsiveTableColumn="invoiceName" [priority]="columnPriorities().invoiceName" scope="col" class="sortable" (click)="toggleSortDirection('Name')">
                            Invoice Name
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == propertyChargeListSortOptions.NameAsc ? '0.9' : '0.3'"
                                [secondaryOpacity]="orderBy == propertyChargeListSortOptions.NameDesc ? '0.9' : '0.3'" />
                        </th>
                        }
                        @if (currentPropertyChargeListViewLocation() !==
                        PropertyChargeListViewLocations.PropertyProfilePage) {
                        <th msResponsiveTableColumn="property" [priority]="columnPriorities().property" scope="col" class="sortable" (click)="toggleSortDirection('Property Title')">
                            Property
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="isPropertyColumnSortAsc() ? '0.9' : '0.3'"
                                [secondaryOpacity]="isPropertyColumnSortDesc() ? '0.9' : '0.3'" />
                        </th>
                        }
                        <th msResponsiveTableColumn="issued" [priority]="columnPriorities().issued" scope="col" class="sortable"
                            (click)="toggleSortDirection('Issued Date')">
                            Issued
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == propertyChargeListSortOptions.IssuedAsc ? '0.9' : '0.3'"
                                [secondaryOpacity]="orderBy == propertyChargeListSortOptions.IssuedDesc ? '0.9' : '0.3'" />
                        </th>
                        <th msResponsiveTableColumn="due" [priority]="columnPriorities().due" scope="col" class="sortable"
                            (click)="toggleSortDirection('Due Date')">
                            Due
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == propertyChargeListSortOptions.DueAsc ? '0.9' : '0.3'"
                                [secondaryOpacity]="orderBy == propertyChargeListSortOptions.DueDesc ? '0.9' : '0.3'" />
                        </th>
                        <th msResponsiveTableColumn="status" [priority]="columnPriorities().status" scope="col" class="sortable" (click)="toggleSortDirection('Status')">
                            Status
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == propertyChargeListSortOptions.StatusAsc ? '0.9' : '0.3'"
                                [secondaryOpacity]="orderBy == propertyChargeListSortOptions.StatusDesc ? '0.9' : '0.3'" />
                        </th>
                        <th msResponsiveTableColumn="owed" [priority]="columnPriorities().owed" scope="col" class="sortable numeric-column"
                            (click)="toggleSortDirection('Amount Owed')">
                            Amount
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == propertyChargeListSortOptions.OwedAmountAsc ? '0.9' : '0.3'"
                                [secondaryOpacity]="orderBy == propertyChargeListSortOptions.OwedAmountDesc ? '0.9' : '0.3'" />
                        </th>
                        <th msResponsiveTableColumn="fees" [priority]="columnPriorities().fees" scope="col" class="sortable numeric-column"
                            (click)="toggleSortDirection('Late Fees')">
                            Late Fees
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == propertyChargeListSortOptions.LateFeesAsc ? '0.9' : '0.3'"
                                [secondaryOpacity]="orderBy == propertyChargeListSortOptions.LateFeesDesc ? '0.9' : '0.3'" />
                        </th>
                        @if (!isProfileView()) {
                        <th msResponsiveTableColumn="paidDate" [priority]="8" scope="col" class="sortable"
                            (click)="toggleSortDirection('Date Paid')">
                            Paid Date
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == propertyChargeListSortOptions.PaidDateAsc ? '0.9' : '0.3'"
                                [secondaryOpacity]="orderBy == propertyChargeListSortOptions.PaidDateDesc ? '0.9' : '0.3'" />
                        </th>
                        }
                        <th msResponsiveTableColumn="actions" [priority]="1" class="fixed-header" scope="col">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Table Row Start -->
                    @for (charge of displayPropertyCharges; let i = $index; track charge.propertyChargeId) {
                    <tr class="align-middle" [className]="(i % 2 === 0) ? 'even' : 'odd'">
                        <td msResponsiveTableColumn="checkbox" [priority]="1">
                            @if (charge.isSelectable) {
                                <input type="checkbox" #toggleSelection class="form-check-input"
                                    [value]="charge.propertyChargeId"
                                    [checked]="selectionItems() | itemSelection: charge.propertyChargeId: isSelectAll"
                                    (click)="selectionClicked({id: charge.propertyChargeId, checked: toggleSelection.checked})" />
                            }
                        </td>
                        <td msResponsiveTableColumn="invoiceId" [priority]="columnPriorities().invoiceId">
                            <span [class.placeholder]="isLoading">{{ charge.propertyChargeId }}</span>
                        </td>
                        @if (showInvoiceNameColumn()) {
                        <td msResponsiveTableColumn="invoiceName" [priority]="columnPriorities().invoiceName">
                            <div class="text-truncate" [class.placeholder]="isLoading"
                                [msTooltip]="charge.name" msTooltipOnlyIfTruncated>{{ charge.name | noValue }}</div>
                        </td>
                        }
                        @if (currentPropertyChargeListViewLocation() !==
                        PropertyChargeListViewLocations.PropertyProfilePage) {
                        <td msResponsiveTableColumn="property" [priority]="columnPriorities().property">
                            <div class="property-info-stack">
                                @if(charge.propertyTitle) {
                                <span class="property-name d-block text-truncate" [msTooltip]="charge.propertyTitle"
                                    msTooltipOnlyIfTruncated [class.placeholder]="isLoading">{{ charge.propertyTitle }}</span>
                                }
                                @if (charge.primaryAddress) {
                                <small class="d-block text-muted lh-sm text-truncate" [msTooltip]="charge.primaryAddress"
                                    msTooltipOnlyIfTruncated [class.placeholder]="isLoading">{{ charge.primaryAddress }}</small>
                                }
                                @if (charge.lotNumber) {
                                <small class="d-block text-muted lh-sm text-truncate"
                                    [msTooltip]="'Lot: ' + charge.lotNumber" msTooltipOnlyIfTruncated [class.placeholder]="isLoading">
                                    <span class="fw-medium">Lot:</span> {{ charge.lotNumber }}
                                </small>
                                }
                            </div>
                        </td>
                        }
                        <td msResponsiveTableColumn="issued" [priority]="columnPriorities().issued">
                            <span [class.placeholder]="isLoading">{{ charge.issuedDate | orgDate: 'shortDate' |
                                noValue}}</span>
                        </td>
                        <td msResponsiveTableColumn="due" [priority]="columnPriorities().due">
                            <span [class.placeholder]="isLoading">{{ charge.dueDate | orgDate: 'shortDate' | noValue }}</span>
                        </td>
                        <td msResponsiveTableColumn="status" [priority]="columnPriorities().status">
                            <ms-status-badge [status]="charge.status" [(isLoading)]="isLoading"></ms-status-badge>
                        </td>
                        <td msResponsiveTableColumn="owed" [priority]="columnPriorities().owed" class="numeric-column">
                            <span [class.placeholder]="isLoading">{{ charge.amount | CurrencyDisplay:
                                charge.currency | noValue}}</span>
                        </td>
                        <td msResponsiveTableColumn="fees" [priority]="columnPriorities().fees" class="numeric-column">
                            <span [class.placeholder]="isLoading">{{ charge.totalLateFees | CurrencyDisplay:
                                charge.currency | noValue }}</span>
                        </td>
                        @if (!isProfileView()) {
                        <td msResponsiveTableColumn="paidDate" [priority]="8">
                            <span [class.placeholder]="isLoading">{{ charge.paidDate | orgDate: 'shortDate' | noValue}}</span>
                        </td>
                        }
                        <td msResponsiveTableColumn="actions" [priority]="1">
                            <div class="dropdown" [msCloseMenuOnSettle]="isChargeActionRunning(charge)">
                                <button class="btn btn-sm btn-ms-secondary dropdown-toggle"
                                    data-bs-toggle="dropdown" [class.placeholder]="isLoading">
                                    Actions
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                    @if (charge.canMarkAsPaid) {
                                    <li *ifHasPermission="{
                                        requiredPermissions: [BalancesPermissions.Mark],
                                        userPermissionOnly: false
                                        }">
                                        <a class="dropdown-item" (click)="markAsPaid(charge)">
                                            <fa-duotone-icon icon="check-circle" secondaryOpacity="0.9"
                                                class="me-2" />Mark as Paid
                                        </a>
                                    </li>
                                    }
                                    @if (charge.canVoid) {
                                    <li *ifHasPermission="{
                                        requiredPermissions: [BalancesPermissions.Mark],
                                        userPermissionOnly: false
                                        }">
                                        <a class="dropdown-item"
                                            [class.disabled]="resolvingVoidBlockChargeId() !== null"
                                            msDebounceClick
                                            (msDebounceClick)="$event.stopPropagation(); voidInvoice(charge)">
                                            @if (resolvingVoidBlockChargeId() === charge.propertyChargeId) {
                                            <span class="spinner-border spinner-border-sm me-2" role="status"></span>Void
                                            } @else {
                                            <fa-duotone-icon icon="ban" secondaryOpacity="0.9" class="me-2" />Void
                                            }
                                        </a>
                                    </li>
                                    }
                                    @if (charge.canWaiveLateFees) {
                                    <li *ifHasPermission="{
                                        requiredPermissions: [BalancesPermissions.Mark],
                                        userPermissionOnly: false
                                        }">
                                        <a class="dropdown-item" (click)="waiveLateFees(charge)">
                                            <fa-duotone-icon icon="hand-holding-dollar" secondaryOpacity="0.9" class="me-2" />Waive Late Fees
                                        </a>
                                    </li>
                                    }
                                    <!-- DEV-2370: hidden for MMP - restore Lock / Add Notes when ready
                                    <li>
                                        <a class="dropdown-item disabled" (click)="lockInvoice(charge)">
                                            <fa-duotone-icon icon="lock" secondaryOpacity="0.9" class="me-2" />Lock
                                        </a>
                                    </li>
                                    <li>
                                        <hr class="dropdown-divider">
                                    </li>
                                    <li>
                                        <a class="dropdown-item disabled" (click)="addNotes(charge)">
                                            <fa-duotone-icon icon="note-sticky" secondaryOpacity="0.9"
                                                class="me-2" />Add Notes
                                        </a>
                                    </li>
                                    -->
                                    <li>
                                        <hr class="dropdown-divider">
                                    </li>
                                    <li>
                                        <a class="dropdown-item"
                                            [class.disabled]="downloadingInvoiceChargeId() !== null"
                                            msDebounceClick
                                            (msDebounceClick)="$event.stopPropagation(); downloadInvoice(charge)">
                                            @if (downloadingInvoiceChargeId() === charge.propertyChargeId) {
                                            <span class="spinner-border spinner-border-sm me-2" role="status"></span>Downloading...
                                            } @else {
                                            <fa-duotone-icon icon="download" secondaryOpacity="0.9" class="me-2" />Download Invoice
                                            }
                                        </a>
                                    </li>
                                    <li *ifHasPermission="{ requiredPermissions: [PaymentPermissions.Read], userPermissionOnly: false }">
                                        <hr class="dropdown-divider">
                                    </li>
                                    <li *ifHasPermission="{ requiredPermissions: [PaymentPermissions.Read], userPermissionOnly: false }">
                                        <a class="dropdown-item"
                                            [class.disabled]="resendingInvoiceChargeId() !== null"
                                            msDebounceClick
                                            (msDebounceClick)="$event.stopPropagation(); resendInvoice(charge)">
                                            @if (resendingInvoiceChargeId() === charge.propertyChargeId) {
                                            <span class="spinner-border spinner-border-sm me-2" role="status"></span>Sending...
                                            } @else {
                                            <fa-duotone-icon icon="paper-plane" secondaryOpacity="0.9"
                                                class="me-2" />Resend Invoice
                                            }
                                        </a>
                                    </li>
                                    <li *ifHasPermission="{
                                        requiredPermissions: [BalancesPermissions.CreateChargeSchedules],
                                        userPermissionOnly: false
                                        }">
                                        <hr class="dropdown-divider">
                                    </li>
                                    <li *ifHasPermission="{
                                        requiredPermissions: [BalancesPermissions.CreateChargeSchedules],
                                        userPermissionOnly: false
                                        }">
                                        <a class="dropdown-item" (click)="openInvoiceLog(charge)">
                                            <fa-duotone-icon icon="clock-rotate-left" secondaryOpacity="0.9"
                                                class="me-2" />Invoice Log
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </td>
                    </tr>
                    }
                    <!-- Table Row End -->
                </tbody>
                <tfoot class="overflow-auto" ms-pagination [take]="take" (loadMoreInView)="loadMoreInView()"
                    [(skip)]="skip" [hasNext]="hasNext" [itemCount]="displayPropertyCharges.length"
                    (jumpToClicked)="jumpToTop($event)">
                </tfoot>
            </table>
        </div>
        <!-- Table End -->

        <!-- Mobile Cards Start -->
        <div id="mobileTableCards" class="d-block d-sm-none mt-3">
            @for (charge of displayPropertyCharges; let i = $index; track charge.propertyChargeId) {
            <div class="card d-flex pt-1 d-inline d-sm-none my-3"
                [msCloseMenuOnSettle]="isChargeActionRunning(charge)">
                <div class="d-flex flex-column card-body">
                    @if (currentPropertyChargeListViewLocation() ===
                    PropertyChargeListViewLocations.PropertyProfilePage) {
                        <div class="d-flex flex-row">
                            <div class="card-left-column d-block-flex text-center">
                                <ms-mobile-card-checkbox [item]="charge" [selectionPrimaryKey]="SelectionPrimaryKeys.PropertyChargeId"
                                    [isSelected]="selectionItems() | itemSelection: charge.propertyChargeId: isSelectAll" [isDisabled]="!charge.isSelectable"
                                    (clicked)="selectionClicked($event)" [checkboxSize]="'md'" [checkboxShape]="'circle'" />
                            </div>

                            <div class="right-card-column w-100">
                                <h5 class="card-title-nowrap" [class.placeholder]="isLoading">{{ charge.name | noValue }}
                                </h5>
                            </div>
                            <div class="far-right-column text-primary text-nowrap text-end">
                                <div class="fs-6" [class.placeholder]="isLoading">#{{ charge.propertyChargeId }}</div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between my-1" [class.placeholder]="isLoading">
                            <span><span class="fw-semibold">Issued:</span> {{ charge.issuedDate | orgDate: 'shortDate' | noValue
                                }}</span>
                            <span><span class="fw-semibold">Due:</span> {{ charge.dueDate | orgDate: 'shortDate' | noValue
                                }}</span>
                        </div>
                        <div class="d-flex justify-content-between my-1" [class.placeholder]="isLoading">
                            <span><span class="fw-semibold">Fees:</span>
                                {{ charge.totalLateFees | CurrencyDisplay: charge.currency | noValue }}</span>
                            @if (charge.paidDate) {
                                <span><span class="fw-semibold">Date Paid:</span> {{ charge.paidDate | orgDate: 'shortDate' }}</span>
                            }
                        </div>
                        <div class="d-flex justify-content-between align-items-center mt-1">
                            <ms-status-badge [status]="charge.status" [(isLoading)]="isLoading"></ms-status-badge>
                            <div class="text-danger fs-5 fw-bold" [class.placeholder]="isLoading">
                                {{ charge.amount | CurrencyDisplay: charge.currency | noValue }}
                            </div>
                        </div>
                    } @else if (currentPropertyChargeListViewLocation() ===
                    PropertyChargeListViewLocations.MemberProfilePage) {
                        <div class="d-flex flex-row">
                            <div class="card-left-column d-block-flex text-center">
                                <ms-mobile-card-checkbox [item]="charge" [selectionPrimaryKey]="SelectionPrimaryKeys.PropertyChargeId"
                                    [isSelected]="selectionItems() | itemSelection: charge.propertyChargeId: isSelectAll" [isDisabled]="!charge.isSelectable"
                                    (clicked)="selectionClicked($event)" [checkboxSize]="'md'" [checkboxShape]="'circle'" />
                            </div>

                            <div class="right-card-column w-100">
                                <h5 class="card-title-nowrap" [class.placeholder]="isLoading">{{ charge.name | noValue }}</h5>
                            </div>
                            <div class="far-right-column text-primary text-nowrap text-end">
                                <div class="fs-6" [class.placeholder]="isLoading">#{{ charge.propertyChargeId }}</div>
                            </div>
                        </div>
                        <div class="my-2">
                            @if (charge.propertyTitle) {
                                <div [class.placeholder]="isLoading">{{ charge.propertyTitle }}</div>
                            }
                            @if (charge.primaryAddress) {
                                <div [class.placeholder]="isLoading">{{ charge.primaryAddress }}</div>
                            }
                            @if (charge.lotNumber) {
                                <div [class.placeholder]="isLoading">
                                    <span class="fw-semibold">Lot #:</span> {{ charge.lotNumber }}
                                </div>
                            }
                        </div>
                        <div class="d-flex justify-content-between my-1" [class.placeholder]="isLoading">
                            <span><span class="fw-semibold">Issued:</span> {{ charge.issuedDate | orgDate: 'shortDate' | noValue }}</span>
                            <span><span class="fw-semibold">Due:</span> {{ charge.dueDate | orgDate: 'shortDate' | noValue }}</span>
                        </div>
                        <div class="d-flex justify-content-between my-1" [class.placeholder]="isLoading">
                            <span><span class="fw-semibold">Fees:</span>
                                {{ charge.totalLateFees | CurrencyDisplay: charge.currency | noValue }}</span>
                        </div>
                        <div class="d-flex justify-content-between align-items-center mt-1">
                            <ms-status-badge [status]="charge.status" [(isLoading)]="isLoading"></ms-status-badge>
                            <div class="text-danger fs-5 fw-bold" [class.placeholder]="isLoading">
                                {{ charge.amount | CurrencyDisplay: charge.currency | noValue }}
                            </div>
                        </div>
                    } @else {
                        <div class="d-flex flex-row">
                            <div class="card-left-column d-block-flex text-center">
                                <ms-mobile-card-checkbox [item]="charge" [selectionPrimaryKey]="SelectionPrimaryKeys.PropertyChargeId"
                                    [isSelected]="selectionItems() | itemSelection: charge.propertyChargeId: isSelectAll" [isDisabled]="!charge.isSelectable"
                                    (clicked)="selectionClicked($event)" [checkboxSize]="'md'" [checkboxShape]="'circle'" />
                            </div>

                            <div class="right-card-column w-100">
                                <h5 class="card-title-nowrap" [class.placeholder]="isLoading">{{ charge.name | noValue }}</h5>
                            </div>
                            <div class="far-right-column text-primary text-nowrap text-end">
                                <div class="fs-6" [class.placeholder]="isLoading">#{{ charge.propertyChargeId }}</div>
                            </div>
                        </div>
                        <div class="my-2">
                            @if (charge.propertyTitle) {
                                <div [class.placeholder]="isLoading">{{ charge.propertyTitle }}</div>
                            }
                            @if (charge.primaryAddress) {
                                <div [class.placeholder]="isLoading">{{ charge.primaryAddress }}</div>
                            }
                            @if (charge.lotNumber) {
                                <div [class.placeholder]="isLoading">
                                    <span class="fw-semibold">Lot #:</span> {{ charge.lotNumber }}
                                </div>
                            }
                            @if (isInvoiceDashboardView()) {
                                <div class="card-text" [class.placeholder]="isLoading">
                                    <span class="fw-semibold">Invoice Name:</span> {{ charge.name | noValue }}
                                </div>
                            }
                        </div>
                        <div class="d-flex justify-content-between my-1" [class.placeholder]="isLoading">
                            <span><span class="fw-semibold">Issued:</span> {{ charge.issuedDate | orgDate: 'shortDate' | noValue }}</span>
                            <span><span class="fw-semibold">Due:</span> {{ charge.dueDate | orgDate: 'shortDate' | noValue }}</span>
                        </div>
                        <div class="d-flex justify-content-between my-1" [class.placeholder]="isLoading">
                            <span><span class="fw-semibold">Fees:</span>
                                {{ charge.totalLateFees | CurrencyDisplay: charge.currency | noValue }}</span>
                            @if (charge.paidDate) {
                                <span><span class="fw-semibold">Date Paid:</span> {{ charge.paidDate | orgDate: 'shortDate' }}</span>
                            }
                        </div>
                        <div class="d-flex justify-content-between align-items-center mt-1">
                            <ms-status-badge [status]="charge.status" [(isLoading)]="isLoading"></ms-status-badge>
                            <div class="text-danger fs-5 fw-bold" [class.placeholder]="isLoading">
                                {{ charge.amount | CurrencyDisplay: charge.currency | noValue }}
                            </div>
                        </div>
                    }
                </div>

                <button class="mobile-action-button dropdown-toggle" data-bs-toggle="dropdown"
                    [class.placeholder]="isLoading">
                    Actions
                </button>
                <ul class="dropdown-menu dropdown-menu-end w-75">
                    @if (charge.canMarkAsPaid) {
                    <li *ifHasPermission="{
                        requiredPermissions: [BalancesPermissions.Mark],
                        userPermissionOnly: false
                        }">
                        <a class="dropdown-item" (click)="markAsPaid(charge)">
                            <fa-duotone-icon icon="check-circle" secondaryOpacity="0.9" class="me-2" />Mark as Paid
                        </a>
                    </li>
                    }
                    @if (charge.canVoid) {
                    <li *ifHasPermission="{
                        requiredPermissions: [BalancesPermissions.Mark],
                        userPermissionOnly: false
                        }">
                        <a class="dropdown-item"
                            [class.disabled]="resolvingVoidBlockChargeId() !== null"
                            msDebounceClick
                            (msDebounceClick)="$event.stopPropagation(); voidInvoice(charge)">
                            @if (resolvingVoidBlockChargeId() === charge.propertyChargeId) {
                            <span class="spinner-border spinner-border-sm me-2" role="status"></span>Void
                            } @else {
                            <fa-duotone-icon icon="ban" secondaryOpacity="0.9" class="me-2" />Void
                            }
                        </a>
                    </li>
                    }
                    @if (charge.canWaiveLateFees) {
                    <li *ifHasPermission="{
                        requiredPermissions: [BalancesPermissions.Mark],
                        userPermissionOnly: false
                        }">
                        <a class="dropdown-item" (click)="waiveLateFees(charge)">
                            <fa-duotone-icon icon="hand-holding-dollar" secondaryOpacity="0.9" class="me-2" />Waive Late Fees
                        </a>
                    </li>
                    }
                    <!-- DEV-2370: hidden for MMP - restore Lock / Add Notes when ready
                    <li>
                        <a class="dropdown-item" (click)="lockInvoice(charge)">
                            <fa-duotone-icon icon="lock" secondaryOpacity="0.9" class="me-2" />Lock
                        </a>
                    </li>
                    <li>
                        <hr class="dropdown-divider">
                    </li>
                    <li>
                        <a class="dropdown-item" (click)="addNotes(charge)">
                            <fa-duotone-icon icon="note-sticky" secondaryOpacity="0.9" class="me-2" />Add Notes
                        </a>
                    </li>
                    -->
                    <li>
                        <hr class="dropdown-divider">
                    </li>
                    <li>
                        <a class="dropdown-item"
                            [class.disabled]="downloadingInvoiceChargeId() !== null"
                            msDebounceClick
                            (msDebounceClick)="$event.stopPropagation(); downloadInvoice(charge)">
                            @if (downloadingInvoiceChargeId() === charge.propertyChargeId) {
                            <span class="spinner-border spinner-border-sm me-2" role="status"></span>Downloading...
                            } @else {
                            <fa-duotone-icon icon="download" secondaryOpacity="0.9" class="me-2" />Download Invoice
                            }
                        </a>
                    </li>
                    <li *ifHasPermission="{ requiredPermissions: [PaymentPermissions.Read], userPermissionOnly: false }">
                        <a class="dropdown-item"
                            [class.disabled]="resendingInvoiceChargeId() !== null"
                            msDebounceClick
                            (msDebounceClick)="$event.stopPropagation(); resendInvoice(charge)">
                            @if (resendingInvoiceChargeId() === charge.propertyChargeId) {
                            <span class="spinner-border spinner-border-sm me-2" role="status"></span>Sending...
                            } @else {
                            <fa-duotone-icon icon="paper-plane" secondaryOpacity="0.9" class="me-2" />Resend Invoice
                            }
                        </a>
                    </li>
                    <li *ifHasPermission="{
                        requiredPermissions: [BalancesPermissions.CreateChargeSchedules],
                        userPermissionOnly: false
                        }">
                        <hr class="dropdown-divider">
                    </li>
                    <li *ifHasPermission="{
                        requiredPermissions: [BalancesPermissions.CreateChargeSchedules],
                        userPermissionOnly: false
                        }">
                        <a class="dropdown-item" (click)="openInvoiceLog(charge)">
                            <fa-duotone-icon icon="clock-rotate-left" secondaryOpacity="0.9" class="me-2" />Invoice Log
                        </a>
                    </li>
                </ul>
            </div>
            }
            <div ms-in-view-port (inViewPort)="loadMoreInView()" ms-pagination [take]="take" [(skip)]="skip"
                [hasNext]="hasNext" [itemCount]="displayPropertyCharges.length" (jumpToClicked)="jumpToTop($event)">
            </div>
        </div>
        <!-- Mobile Cards End -->
    </div>
</div>

<!-- Mark Invoice Modal -->
<ms-mark-invoice-modal #markInvoiceModalRef
    (markCompleted)="onMarkCompleted($event)" />

<!-- Waive Late Fees Confirmation Modal -->
<ms-confirmation-modal #waiveLateFeesConfirmationModalRef
    [modalId]="'waiveLateFeesConfirmationModal'"
    (confirmed)="onWaiveConfirmed($event)"
    (cancelled)="onWaiveCancelled()" />

<!-- Waive Late Fees Info Modal -->
<ms-info-modal #waiveLateFeesInfoModalRef
    [modalId]="'waiveLateFeesInfoModal'" />

<!-- Resend Invoice Info Modal -->
<ms-info-modal #resendInvoiceInfoModalRef
    [modalId]="'resendInvoiceInfoModal'" />

<!-- Bulk Resend Invoices Confirmation Modal -->
<ms-confirmation-modal #bulkResendInvoicesConfirmationModalRef
    [modalId]="'bulkResendInvoicesConfirmationModal'"
    (confirmed)="onBulkResendInvoicesConfirmed()"
    (cancelled)="onBulkResendInvoicesCancelled()" />

<!-- Bulk Resend Invoices Info Modal -->
<ms-info-modal #bulkResendInvoicesInfoModalRef
    [modalId]="'bulkResendInvoicesInfoModal'" />

<!-- Void Blocked Modal -->
<ms-confirmation-modal #voidBlockedConfirmationModalRef
    [modalId]="'invoiceVoidBlockedModal'"
    confirmButtonText="Go to Payment Dashboard"
    cancelButtonText="Cancel"
    (confirmed)="goToPaymentDashboard()"
    (cancelled)="dismissVoidBlocked()" />

<!-- Void Blocked Info Modal -->
<ms-info-modal #voidBlockedInfoModalRef
    [modalId]="'invoiceVoidBlockedInfoModal'"
    (onConfirm)="voidBlockedInfoConfirmed()" />

<!-- Invoice Log Modal -->
<ms-invoice-log-modal #invoiceLogModalRef />